<template>
	<div id="app" style="height: 100%; overflow-y: auto">
		<div id="content" class="testBtn" style="height: 0"></div>
		<router-view :key="$route.fullPath"></router-view>
	</div>
</template>

<script>
export default {
	name: 'App',
	provide() {
		return {
			reload: this.reload,
		}
	},
	data() {
		return {
			isRouterAlive: true,
		}
	},
	created() {
		console.log('process.env.NODE_ENV')
		console.log(process.env.NODE_ENV)
		if (process.env.NODE_ENV === 'production') {
			console.log('加载百度js')
			var _hmt = _hmt || [];
			(function () {
				var hm = document.createElement('script');
				hm.src = 'https://hm.baidu.com/hm.js?ea636c83ea55d29e89a95e5949510367';
				var s = document.getElementsByTagName('script')[0];
				s.parentNode.insertBefore(hm, s);
			})();
			console.log('加载客服js')
				; (function (w, d, e, x) {
					w[e] = function () {
						w.cbk = w.cbk || []
						w.cbk.push(arguments)
					}
					x = d.createElement('script')
					x.async = true
					x.id = 'zhichiScript'
					x.className = 'testBtn'
					x.src =
						'https://chat.soboten.com/chat/frame/v6/entrance.js?sysnum=02e069d2757f48968dfd7a751128727d'
					//方式一
					// x.setAttribute('data-args', 'color=04babc&location=1');
					d.body.appendChild(x)
				})(window, document, 'zc')
			//方式二
			zc('config', {
				// color: '04babc',
				// location: 1,
				custom: true,
				anchor: true,
			})
		} else {
			console.log('不加载百度js、客服js')
		}
	},
	methods: {
		reload() {
			this.isRouterAlive = false
			this.$nextTick(function () {
				this.isRouterAlive = true
			})
		},
	},
}
</script>

<style>
#app {
	height: 100%;
	/*标题设计方面的字体,Mac OS系统的默认字体,苹果设备字体,苹果丽黑字体,微软雅黑,微软无衬线字体,西方字母无衬线字体*/
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
		Microsoft YaHei, Arial, sans-serif !important;
}

.van-dialog__footer .van-button {
	background: #00754A !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue